function unSerializeTable(schema, list) {
  const final = [];
  list.forEach((row) => {
    const result = [];
    for (let i = 0; i < schema.length; i++) {
      const element = schema[i].name;
      result.push({ ...schema[i], value: row[element] });
    }
    final.push(result);
  });

  return final;
}

export default unSerializeTable;
